import gerard from '../assets/images/gerard.jpg';
import paolo from '../assets/images/paolo.jpg';
import pepe from '../assets/images/pepe.jpg';

const reviewsItemsData = [
    {
        avatar: gerard,
        name: 'Gerard Castor',
        rating: 5,
        text:
            'Graduate of De La Salle - College of Saint Benilde with a degree BSBA - Human Resource \n' +
            'Management. Currently an International Property Specialist under Ayala Land International. \n' +
            'Has worked with clients in Australia, Singapore, UAE, and USA. Knowledgeable in Marketing, Sales, \n' +
            'and Customer Service Recovery.',
        username: 'Founder',
    },

    {
        avatar: paolo,
        name: 'Paolo Clavel',
        rating: 5,
        text:
            'Graduate of De La Salle – College of Saint Benilde with a degree of BSBA - Human Resource \n' +
            'Management. Currently, finishing a Diploma in Construction and Project Management at the \n' +
            'same institution. Worked as a Program Support Assistant and Compensation Assistant in the \n' +
            'banking industry for two years. Currently manages the family business (Worldlinks Cable \n' +
            'Works) that has been in the I.T/Construction Service since 2004. ',
        username: 'Co-Founder',
    },

    {
        avatar: pepe,
        name: 'Jose Gil Puey IV',
        rating: 5,
        text:
            'Graduate of Mapua Institute of Technology BS in Computer Science. Worked with various \n' +
            'companies including SGV, IBM, UCPB, Thales (Gemalto) and Pumanila. Experienced in the \n' +
            'fields of cybersecurity and programming. Developer and Creator of AR (Augmented Reality) \n' +
            'and Practitioner of Cybersecurity best practices and IT risk compliance.',
        username: 'Co-Founder',
    },
];

const getReviewsItemsData = () => reviewsItemsData;

export default getReviewsItemsData;
